module.exports = __webpack_public_path__ + "img/dtImg.a85b1c11.png";